import { CosmicIcons } from './CosmicIcons';
export const VuetifyTheme = {
    options: {
        customProperties: true
    },
    iconfont: 'fa',
    icons: CosmicIcons,
    theme: {}
};
